import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const ServerErrorPage = () => {
  return (
    <>
      <Helmet>
        <title>500 - Server Error | Abacies Logiciels</title>
        <meta name="description" content="We're experiencing technical difficulties. Please try again later or contact support." />
      </Helmet>

      <div className="min-h-screen bg-alabaster flex items-center justify-center px-4">
        <div className="max-w-2xl w-full text-center">
          {/* Error Illustration */}
          <div className="mb-8">
            <div className="relative inline-block">
              <div className="text-9xl md:text-[200px] font-bold text-coral-mist opacity-10">500</div>
              <div className="absolute inset-0 flex items-center justify-center">
                <svg className="w-32 h-32 md:w-48 md:h-48 text-coral-mist animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Error Message */}
          <h1 className="text-4xl md:text-5xl font-bold text-charcoal mb-4 animate-fade-in">
            Server Error
          </h1>
          <p className="text-xl text-titanium mb-8 animate-slide-up">
            We're experiencing technical difficulties. Our team has been notified and is working on a fix.
          </p>

          {/* Status Information */}
          <div className="bg-white rounded-lg p-6 mb-8 shadow-sm animate-slide-up" style={{ animationDelay: '0.1s' }}>
            <div className="flex items-center justify-center mb-4">
              <div className="w-3 h-3 bg-coral-mist rounded-full animate-pulse mr-2"></div>
              <span className="text-titanium">System Status: Investigating Issue</span>
            </div>
            <p className="text-sm text-titanium">
              This is usually temporary. Please try refreshing the page in a few moments.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up" style={{ animationDelay: '0.2s' }}>
            <button 
              onClick={() => window.location.reload()} 
              className="btn-primary"
            >
              Refresh Page
            </button>
            <Link to="/" className="btn-secondary">
              Return Home
            </Link>
          </div>

          {/* Troubleshooting Steps */}
          <div className="mt-12 bg-white rounded-lg p-6 text-left animate-slide-up" style={{ animationDelay: '0.3s' }}>
            <h2 className="text-lg font-semibold text-charcoal mb-3">What you can try:</h2>
            <ul className="space-y-2 text-sm text-titanium">
              <li className="flex items-start">
                <svg className="w-5 h-5 text-primary-red mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Wait a few moments and refresh the page
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-primary-red mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Clear your browser cache and cookies
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-primary-red mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Try accessing the site from a different browser
              </li>
              <li className="flex items-start">
                <svg className="w-5 h-5 text-primary-red mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Check our status page for updates
              </li>
            </ul>
          </div>

          {/* Support Contact */}
          <div className="mt-8 text-sm text-titanium animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <p>Error Code: 500 | Reference ID: {Math.random().toString(36).substr(2, 9).toUpperCase()}</p>
            <p className="mt-2">
              Need immediate assistance? Contact us at{' '}
              <a href="mailto:support@abacies.com" className="text-primary-red hover:underline">
                support@abacies.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServerErrorPage;
